// ============================================================
// MOCK DATA — Abhi Insurance Agency (frontend-only version)
// All form submissions are stored in localStorage for now.
// Replace with real API calls during backend integration.
// ============================================================

export const COMPANY = {
  name: "Abhi Insurance",
  legalName: "Abhi Insurance Agency Inc.",
  tagline: "Protecting You Always",
  phone: "+1 (604) 996-6862",
  phoneAlt: "+1 (604) 227-9410",
  phoneHref: "tel:+16049966862",
  email: "info@abhifinancial.com",
  address: "Surrey, British Columbia, Canada",
  hours: "Open 7 Days a Week · 09:00 – 17:00",
  since: 2000,
  owner: "Sandeep Ahuja",
};

export const STATS = [
  { value: 20, suffix: "+", label: "Years of Trusted Service" },
  { value: 45, suffix: "%", label: "Premium Savings — Up To" },
  { value: 8, suffix: "x", label: "'Top of the Table' Designation" },
  { value: 7, suffix: "", label: "Days a Week Availability" },
];

export const CREDENTIALS = [
  "MDRT Member since 2010",
  "Advocis Member",
  "CHS Designation",
  "8x 'Top of the Table'",
  "Fully Licensed in BC",
  "5-Star Client Reviews",
];

export const SERVICES = [
  {
    slug: "super-visa-insurance",
    title: "Super Visa Insurance",
    short:
      "Mandatory medical coverage for parents and grandparents visiting Canada on the Super Visa program — with minimum $100,000 coverage from a Canadian insurer.",
    image:
      "https://images.pexels.com/photos/8317703/pexels-photo-8317703.jpeg",
    heroImage:
      "https://images.pexels.com/photos/6149192/pexels-photo-6149192.jpeg?auto=compress&cs=tinysrgb&w=2000",
    sectionImages: [
      "https://images.pexels.com/photos/723240/pexels-photo-723240.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/3768131/pexels-photo-3768131.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    icon: "PlaneTakeoff",
    heroLine: "Extending your stay in Canada!",
    intro:
      "If you're planning an extended stay in Canada to visit your child or grandchild, you'll want to apply for the Super Visa — and to qualify, you'll need Super Visa Insurance. As your Super Visa insurance advisor, Abhi Insurance Agency partners with Canada's leading insurance companies to guarantee you the best rates and most trustworthy service possible.",
    sections: [
      {
        heading: "What is the Super Visa?",
        body:
          "The Super Visa allows a parent or grandparent of a Canadian citizen or permanent resident to visit their relative in Canada for up to 5 years at a time. The visa allows multiple entries and remains valid for up to 10 years.",
        bullets: [
          "Be the parent or grandparent of a Canadian citizen or permanent resident of Canada",
          "Have a written invitation from your child or grandchild living in Canada, including a promise of financial support",
          "Have Super Visa medical insurance from a Canadian insurance company",
        ],
      },
      {
        heading: "What is Super Visa Insurance?",
        body:
          "Super Visa insurance is the medical insurance you must hold for the duration of your extended stay. It guarantees you and your family can affordably access emergency medical care if anyone is injured or becomes ill during the visit.",
        bullets: [
          "Obtained from an insurance provider located in Canada",
          "Purchased prior to entering Canada",
          "Proof of payment shown when applying for the Super Visa",
          "Valid for at least 1 year from the date of entry",
          "Provides at least $100,000 in coverage",
        ],
      },
    ],
    why: [
      "FREE advice consultation with an expert Super Visa insurance advisor — by phone or in person",
      "No hidden fees, ever",
      "Experienced, friendly and patient agents",
      "We represent Canada's best insurance companies, providing reliable and affordable coverage since 2000",
    ],
    ctaText:
      "Contact us for a free consultation with one of our experienced Super Visa Insurance agents. We'll help you understand your options and choose the right policy from one of our leading insurance partners.",
  },
  {
    slug: "visitor-visa-insurance",
    title: "Visitor Visa Insurance",
    short:
      "Emergency medical protection for anyone visiting Canada — for a brief trip, an extended stay, or while waiting for provincial health coverage to begin.",
    image:
      "https://images.unsplash.com/photo-1504150558240-0b4fd8946624",
    heroImage:
      "https://images.pexels.com/photos/1268855/pexels-photo-1268855.jpeg?auto=compress&cs=tinysrgb&w=2000",
    sectionImages: [
      "https://images.pexels.com/photos/3769138/pexels-photo-3769138.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/1008155/pexels-photo-1008155.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    icon: "Luggage",
    heroLine: "Prepare for the unexpected while you're traveling!",
    intro:
      "Visitor visa insurance is an important purchase for anyone planning to visit Canada — whether you're here for a brief visit, an extended stay, or if you plan to make Canada your new home. While you remain in the country, your visitor visa insurance keeps you protected in case of an accident or another emergency.",
    sections: [
      {
        heading: "Why do you need visitor visa insurance?",
        body:
          "Canada's universal health coverage only applies to citizens and lawful residents. If you're just visiting, or waiting for your Canadian health coverage to begin, you must be prepared with your own medical insurance. Without it, an accident or illness could cost you thousands of dollars.",
        bullets: [
          "Affordable protection against expensive emergency medical costs",
          "Some policies also cover you while traveling to and from Canada",
          "Side trips to other countries may also be covered",
        ],
      },
      {
        heading: "What type of coverage do you need?",
        body:
          "Our advisors recommend a policy that covers accidents and medical emergencies for the entire time you're in Canada — and even while you travel to and from the country. Working with a Canada-based agency ensures your coverage is comprehensive and your insurer knows Canada's health care system best.",
        bullets: [
          "Valid for your entire stay in Canada",
          "Coverage from a trusted Canadian insurer",
          "Expert guidance on the right coverage amount for your travel plans",
        ],
      },
    ],
    why: [
      "Experts at finding the best rates based on your budget and travel plans",
      "FREE consultation with a visitor visa insurance advisor",
      "Representing Canada's best insurance companies since 2000",
    ],
    ctaText:
      "Don't wait until it's too late! It's best to purchase your visitor visa insurance before you arrive in Canada. Contact us today to speak with a visitor visa insurance advisor.",
  },
  {
    slug: "life-insurance",
    title: "Life Insurance",
    short:
      "Protect your family from financial loss and give them the gift of security and peace of mind — with the right policy at the right rate.",
    image:
      "https://images.pexels.com/photos/7938055/pexels-photo-7938055.jpeg",
    heroImage:
      "https://images.pexels.com/photos/3768114/pexels-photo-3768114.jpeg?auto=compress&cs=tinysrgb&w=2000",
    sectionImages: [
      "https://images.pexels.com/photos/1128318/pexels-photo-1128318.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/3768146/pexels-photo-3768146.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    icon: "HeartHandshake",
    heroLine: "The gift of financial security!",
    intro:
      "Life insurance is an essential purchase for anyone who provides for their family. Its most important purpose is to protect loved ones from financial loss when the wage earner dies — ensuring they remain in their home, pay bills and keep up with everyday expenses. With life insurance, you provide your family with the gift of financial security and peace of mind.",
    sections: [
      {
        heading: "Purchasing Life Insurance",
        body:
          "Purchasing life insurance can be intimidating or confusing, especially when you must consider multiple quotes from different companies with varying benefits and conditions. Abhi Insurance Agency takes the guesswork out of choosing life insurance — our advisors listen, research every available option, and advise you on which policies fit best.",
        bullets: [
          "We compare rates and benefits across Canada's most trusted insurers",
          "Clear, jargon-free explanations of every option",
          "No pressure — plenty of time to ask questions and decide",
        ],
      },
      {
        heading: "What to expect from your advisor",
        body:
          "Your friendly advisor will ask a few questions about your age, marital status, family and financial situation. Based on your budget and unique circumstances, they'll compare policies, explain your options in clear language, and purchase your policy only when you're fully confident.",
        bullets: [
          "Personalized needs analysis",
          "Side-by-side comparison of leading Canadian insurers",
          "Support available 7 days a week — even after you purchase",
        ],
      },
    ],
    why: [
      "Fully licensed life insurance agency",
      "FREE advice consultations — by phone or in person, no obligations",
      "No hidden fees, personalized advice and support",
      "Helping Canadians save on life insurance since 2000 — available 7 days a week",
    ],
    ctaText:
      "Contact us for a free consultation with one of our experienced Life Insurance agents. We'll help you understand your options and choose the right policy from one of our leading insurance partners.",
  },
  {
    slug: "critical-illness-insurance",
    title: "Critical Illness Insurance",
    short:
      "A lump-sum benefit upon diagnosis of a covered critical illness — so you can focus on recovery, not medical bills or lost income.",
    image:
      "https://images.pexels.com/photos/7578798/pexels-photo-7578798.jpeg",
    heroImage:
      "https://images.pexels.com/photos/3845983/pexels-photo-3845983.jpeg?auto=compress&cs=tinysrgb&w=2000",
    sectionImages: [
      "https://images.pexels.com/photos/5452201/pexels-photo-5452201.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/7659564/pexels-photo-7659564.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    icon: "Activity",
    heroLine: "Focus on recovery, not finances!",
    intro:
      "A critical illness diagnosis can bring large, burdensome medical expenses and the loss of regular wages. Critical illness insurance provides a lump-sum payment upon diagnosis of a covered condition, giving you and your family the financial security and peace of mind you need during one of life's most unexpected events.",
    sections: [
      {
        heading: "Why do you need critical illness insurance?",
        body:
          "When you prepare with critical illness coverage, you protect your family's finances from the ripple effects of a serious diagnosis — from treatment costs to everyday bills.",
        bullets: [
          "No worrying about expensive medical bills or growing debt",
          "Access the very best care and medications that may not be covered by government health plans",
          "Replace lost or reduced income if you or your spouse cannot work",
          "Afford professional help around the house while you cope with your illness",
          "Focus fully on your recovery",
        ],
      },
      {
        heading: "What's covered?",
        body:
          "The conditions covered differ from insurer to insurer — many plans cover cancers, heart conditions and stroke at various severity levels. Our advisors help you compare what is (and isn't) covered, choose an adequate coverage amount, and weigh factors like claim settlement history and service quality — not just price.",
        bullets: [
          "Coverage comparison across leading Canadian insurers",
          "Guidance on the right coverage size for your financial situation",
          "Transparent explanation of exclusions before you buy",
        ],
      },
    ],
    why: [
      "FREE advice consultation with an expert critical illness advisor — by phone or in person",
      "Experienced, friendly and patient agents",
      "No hidden fees",
      "Reliable and affordable coverage from Canada's best insurers since 2000",
    ],
    ctaText:
      "Still not sure critical illness insurance is the right solution for you? Call us today for a free consultation with an experienced critical illness insurance advisor.",
  },
  {
    slug: "disability-insurance",
    title: "Disability Insurance",
    short:
      "Income protection if illness or injury keeps you from working — covering your expenses with a temporary monthly income.",
    image:
      "https://images.unsplash.com/photo-1570793005299-c091be91bbad",
    heroImage:
      "https://images.pexels.com/photos/4497828/pexels-photo-4497828.jpeg?auto=compress&cs=tinysrgb&w=2000",
    sectionImages: [
      "https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=1200",
      "https://images.pexels.com/photos/4064696/pexels-photo-4064696.jpeg?auto=compress&cs=tinysrgb&w=1200",
    ],
    icon: "ShieldCheck",
    heroLine: "Protect your most valuable asset — your income!",
    intro:
      "If you become ill or are injured in an accident and can no longer work, disability insurance covers your expenses and pays a temporary monthly income. It's essential protection for any working person, shielding you and your loved ones from the unexpected financial losses a disability can cause.",
    sections: [
      {
        heading: "Why disability insurance matters",
        body:
          "Your ability to earn an income is likely your most valuable financial asset. A disability — even a temporary one — can interrupt that income for months or years. Disability insurance bridges the gap so your family's lifestyle and savings stay protected.",
        bullets: [
          "Monthly benefit replaces a portion of your income while you can't work",
          "Covers everyday living expenses, bills and commitments",
          "Options for both short-term and long-term protection",
        ],
      },
      {
        heading: "Finding the right plan",
        body:
          "When you consult with your disability insurance advisor, share as much information about your financial circumstances as possible — your income, typical bills and living expenses, and the amount you can afford for coverage. We'll find the right plan that fits your needs now and in the future.",
        bullets: [
          "Personalized needs and budget assessment",
          "Comparison of waiting periods, benefit periods and definitions of disability",
          "Clear advice with no pressure",
        ],
      },
    ],
    why: [
      "FREE consultation with an experienced disability insurance advisor",
      "No hidden fees",
      "Tailored recommendations for your income and lifestyle",
      "Trusted by Canadian families since 2000",
    ],
    ctaText:
      "If you'd like to consider your options for disability insurance, contact us today. We'll look for the right plan that fits your financial needs now and in the future.",
  },
];

export const WHY_CHOOSE = [
  {
    icon: "MessagesSquare",
    title: "Free Advice Consultations",
    text:
      "Speak with an insurance advisor over the phone or in person — completely free, with no obligations.",
  },
  {
    icon: "BadgeCheck",
    title: "No Hidden Fees",
    text:
      "Total transparency from your first consultation to your final policy. What we quote is what you pay.",
  },
  {
    icon: "UserCheck",
    title: "In-House Claim Assistance",
    text:
      "A dedicated claim assistance manager works directly with clients when you need support most.",
  },
  {
    icon: "Clock",
    title: "Same-Day Partial Refunds",
    text:
      "Partial refunds are processed on the very same day. Your money moves as fast as you do.",
  },
  {
    icon: "Star",
    title: "5-Star Rated Service",
    text:
      "Consistently rated 5 stars by our satisfied clients across Surrey and the Lower Mainland.",
  },
  {
    icon: "Trophy",
    title: "Industry Recognition",
    text:
      "Designated 'Top of the Table' 8 times, MDRT member since 2010, Advocis member with CHS designation.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Doug Ramsey",
    role: "Criminal Lawyer",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    text:
      "I am so pleased and satisfied with this insurance company's service. It is so great to work with an adviser who is truly interested in their client's needs, goals and preferences. I am really impressed with their commitment.",
  },
  {
    name: "Bessie Sanders",
    role: "Production Manager",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956",
    text:
      "They have assembled only certified and experienced advisors who stand behind their promise to deliver quality and timely services. It is so great to work with specialists who are truly interested in their client's needs and goals.",
  },
  {
    name: "Sara Garcia",
    role: "School Teacher",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
    text:
      "I want to express how grateful I am for the work you have done for my family over the past years. They work through the process to identify your needs, goals and strategy, and put your plan into action!",
  },
];

export const ADVISOR = {
  name: "Sandeep Ahuja",
  role: "Founder & Licensed Insurance Advisor",
  image:
    "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg",
  bio:
    "Since 2000, Sandeep Ahuja has been helping Canadians, Canadian immigrants and visitors with all their insurance needs. A fully licensed insurance advisor, MDRT member since 2010 and 8-time 'Top of the Table' designee, Sandeep is an expert at providing clients with tailored advice — comparing the benefits and drawbacks of plans across companies so every client is confident they have the best possible coverage for their needs and budget.",
  highlights: [
    "MDRT Member since 2010",
    "8x 'Top of the Table'",
    "Advocis Member",
    "CHS Designation",
  ],
};

// ============================================================
// UPDATED BLOG ARTICLES
// Existing dates, excerpts, slugs and article images preserved.
// ============================================================

export const BLOG_POSTS = [
  {
    slug: "super-visa-insurance-requirements-guide",
    title:
      "Super Visa Insurance Requirements: A Complete Guide for Parents and Grandparents",
    category: "Super Visa",
    date: "July 14, 2025",
    readTime: "8 minutes",
    image:
      "https://images.pexels.com/photos/8317705/pexels-photo-8317705.jpeg",
    excerpt:
      "Planning to bring your parents or grandparents to Canada for an extended stay? Here's everything you need to know about Super Visa insurance requirements — coverage minimums, validity rules, and how to qualify.",
    author: "Sandeep Ahuja",
    authorRole: "Founder and Licensed Insurance Advisor",
    authorOrganization: "Abhi Insurance Agency",
    metaTitle:
      "Super Visa Insurance Requirements | Complete Guide | Abhi Insurance",
    metaDescription:
      "What Super Visa insurance actually requires: $100,000 minimum coverage, 12 month validity, approved insurers and proof of payment. Written by a licensed advisor in Surrey BC.",
    related: [
      {
        slug: "how-much-life-insurance-do-you-need",
        label: "How Much Life Insurance Do You Actually Need",
      },
      {
        slug: "choosing-critical-illness-insurance-plan",
        label: "What To Know Before Choosing a Critical Illness Plan",
      },
    ],
    content: [
      {
        type: "p",
        text:
          "Every few weeks somebody calls this office in a panic because a Super Visa application has been held up over the insurance. Almost always it is the same handful of mistakes: a policy bought for the length of the visit rather than a full year, a certificate that does not show proof of payment, or coverage that technically satisfies the requirement but excludes the one condition the applicant actually has.",
      },
      {
        type: "p",
        text:
          "None of it is complicated. It is just easy to get wrong when you are doing it for the first time, under time pressure, from a list of quotes that all look roughly the same.",
      },
      {
        type: "p",
        text:
          "Here is what the insurance requirement actually involves and where families most often trip.",
      },
      {
        type: "h2",
        text: "First, what the Super Visa is",
      },
      {
        type: "p",
        text:
          "The Super Visa allows a parent or grandparent of a Canadian citizen or permanent resident to visit family in Canada for up to 5 years at a time. It permits multiple entries and remains valid for up to 10 years, which is what separates it from an ordinary visitor visa.",
      },
      {
        type: "p",
        text:
          "Worth noting because outdated information circulates widely: the maximum stay per entry used to be 2 years. It is no longer. If you are reading a page that still says 2 years, it has not been updated in a long while, and you should be careful about what else on it is stale.",
      },
      {
        type: "h2",
        text: "The four insurance requirements",
      },
      {
        type: "p",
        text:
          "To satisfy the application, the medical insurance policy must:",
      },
      {
        type: "p",
        text:
          "**Provide at least $100,000 in coverage** for health care, hospitalization and repatriation.",
      },
      {
        type: "p",
        text:
          "**Be valid for at least 12 months** from the date of entry into Canada. This is the requirement people most often misread. The policy must run a full year regardless of how long the visit is expected to last. A six month policy for a six month visit will not be accepted.",
      },
      {
        type: "p",
        text:
          "**Come from an approved provider.** The list of acceptable insurers is set by the immigration authorities and has been revised before, so it is worth confirming rather than assuming.",
      },
      {
        type: "p",
        text:
          "**Show proof of payment**, either paid in full or through an approved instalment arrangement.",
      },
      {
        type: "h2",
        text: "When to buy it",
      },
      {
        type: "p",
        text:
          "The policy has to be in place before entry to Canada, and the proof of payment forms part of the application itself. So the practical answer is: before you submit.",
      },
      {
        type: "p",
        text:
          "There is a second reason to move early. Buying with three weeks to spare gives you time to compare properly. Buying with three days to spare means taking whatever quote arrives first, which is how families end up paying several hundred dollars more than they needed to for coverage that fits worse.",
      },
      {
        type: "h2",
        text: "The four mistakes that cause problems",
      },
      {
        type: "p",
        text:
          "**Buying for the visit rather than the year.** Covered above, and the most common one by a distance.",
      },
      {
        type: "p",
        text:
          "**Ignoring preexisting conditions.** A policy that excludes an applicant's diabetes or heart condition still satisfies the visa requirement. It also pays nothing if that condition is what puts them in hospital. Passing the application and having real protection are two different things, and only one of them matters at 2am in an emergency room.",
      },
      {
        type: "p",
        text:
          "**Choosing on price alone.** Two policies at similar premiums can differ enormously on the stability period they require, the deductible, and what they exclude. The premium is the least informative number on the page.",
      },
      {
        type: "p",
        text:
          "**Leaving it until the last week.** Rushed applications are where errors happen, and errors mean delays.",
      },
      {
        type: "h2",
        text: "How to bring the premium down",
      },
      {
        type: "p",
        text:
          "**Compare several insurers.** Rates for identical coverage vary widely. This is the single biggest lever and it costs nothing but time.",
      },
      {
        type: "p",
        text:
          "**Consider a higher deductible.** Accepting more out of pocket on a claim can reduce the premium noticeably. Whether that trade is worth it depends on the family's finances, not on a rule of thumb.",
      },
      {
        type: "p",
        text:
          "**Ask about instalment plans.** Spreading the cost across the year does not usually reduce the total, but it changes the cash flow considerably, which for many families is the real obstacle.",
      },
      {
        type: "p",
        text:
          "**Work with a licensed advisor.** Advisors access rates that are not always available directly, and more usefully, they know which insurer treats a given medical history most favourably.",
      },
      {
        type: "h2",
        text: "What happens if the visa is refused",
      },
      {
        type: "p",
        text:
          "You get your money back. Every Super Visa policy we place carries a full refund if the application is refused, which means buying before the decision carries no financial risk. If the visit is cut short and the applicant goes home early, a partial refund applies for the unused portion.",
      },
      {
        type: "h2",
        text: "The short version",
      },
      {
        type: "p",
        text:
          "Buy a policy for at least $100,000, valid at least 12 months from entry, from an approved provider, with proof of payment. Do it before you submit the application. Compare more than one insurer. And be honest about medical history, because a cheap policy that excludes the condition someone actually has is not really coverage at all.",
      },
      {
        type: "p",
        text:
          "At Abhi Insurance Agency we compare Canada's leading Super Visa providers so families get coverage that meets the requirements at the best available rate. Consultations are free, 7 days a week.",
      },
      {
        type: "p",
        text:
          "**Call (604) 996 6862** 8128 128 St #302, Surrey, BC V3W 1R1 [info@abhifinancial.com](mailto\\:info@abhifinancial.com)",
      },
    ],
  },
  {
    slug: "choosing-critical-illness-insurance-plan",
    title:
      "What You Need To Know Before Choosing a Critical Illness Insurance Plan",
    category: "Critical Illness",
    date: "June 28, 2025",
    readTime: "7 minutes",
    image:
      "https://images.unsplash.com/photo-1637763723578-79a4ca9225f7",
    excerpt:
      "Critical illness insurance offers a lump sum upon diagnosis — but coverage differs from insurer to insurer. Here are the key points to review before you buy.",
    author: "Sandeep Ahuja",
    authorRole: "Founder and Licensed Insurance Advisor",
    authorOrganization: "Abhi Insurance Agency",
    metaTitle:
      "Choosing a Critical Illness Insurance Plan in Canada | Abhi Insurance",
    metaDescription:
      "Covered conditions, exclusions, survival periods and coverage amounts. What to check before buying critical illness insurance in Canada, from a licensed advisor.",
    related: [
      {
        slug: "super-visa-insurance-requirements-guide",
        label: "Super Visa Insurance Requirements",
      },
      {
        slug: "denied-life-insurance-what-to-do-next",
        label: "Denied Life Insurance? Here's What To Do Next",
      },
    ],
    content: [
      {
        type: "p",
        text:
          "Critical illness insurance is the product clients understand least and ask about most. The concept is simple enough: you are diagnosed with a covered condition, the insurer pays you a lump sum, and the money is yours to use however you want. No receipts, no restrictions, no reimbursement process.",
      },
      {
        type: "p",
        text:
          "The complexity is entirely in the fine print. Two policies with the same premium and the same headline benefit can behave completely differently when a claim is made. Here is what actually separates them.",
      },
      {
        type: "h2",
        text: "There is no standard list of covered conditions",
      },
      {
        type: "p",
        text:
          "This surprises people. Critical illness is not a regulated product with a fixed definition, so what is covered is whatever the insurer says is covered.",
      },
      {
        type: "p",
        text:
          "Nearly every plan includes cancer, heart attack and stroke, which between them account for the large majority of claims. Comprehensive plans extend to 25 or more conditions, adding multiple sclerosis, Parkinson's disease, major organ transplant, severe burns, loss of limbs and loss of independence.",
      },
      {
        type: "p",
        text:
          "Whether the longer list is worth paying for depends on your family medical history more than on anything else. Read the actual list. Do not assume two plans that both advertise comprehensive coverage cover the same things.",
      },
      {
        type: "h2",
        text: "The severity definitions matter more than the list",
      },
      {
        type: "p",
        text:
          "This is where most disappointment comes from. A policy can say it covers cancer and still pay nothing for a cancer diagnosis.",
      },
      {
        type: "p",
        text:
          "Early stage and less aggressive cancers are commonly excluded outright or paid at a reduced percentage, often 10 or 25 percent of the benefit. Certain skin cancers and early prostate diagnoses are frequently carved out. Heart attack definitions can require specific enzyme readings or ECG changes.",
      },
      {
        type: "p",
        text:
          "None of this is hidden. It is written in the contract. It is just written in language nobody reads before signing, and it is the single thing most worth having an advisor walk you through.",
      },
      {
        type: "h2",
        text: "Check the survival period",
      },
      {
        type: "p",
        text:
          "Most policies pay only if the insured survives a set number of days after diagnosis. Thirty days is typical. Some policies use longer periods, some shorter.",
      },
      {
        type: "p",
        text:
          "It is a small clause with a large consequence, and it takes ten seconds to check.",
      },
      {
        type: "h2",
        text: "How much coverage to buy",
      },
      {
        type: "p",
        text:
          "The common starting point is one to two years of household income. The reasoning is practical rather than actuarial: that is roughly enough to stop working, get treatment, and recover without draining savings or cashing out retirement funds.",
      },
      {
        type: "p",
        text:
          "If your aim is narrower, the number can be smaller. Some clients want only enough to cover mortgage payments for two years. Others want enough to fund a treatment not available through the provincial plan. Both are perfectly reasonable, and both produce a lower figure than the default.",
      },
      {
        type: "p",
        text:
          "What matters is that the number reflects something specific rather than being a round figure somebody suggested.",
      },
      {
        type: "h2",
        text: "Look at what is excluded",
      },
      {
        type: "p",
        text:
          "Exclusions deserve as much attention as inclusions. Preexisting conditions are the main one, alongside diagnoses made within a waiting period after the policy starts, and conditions arising from specific circumstances.",
      },
      {
        type: "p",
        text:
          "If you have an existing condition, disclose it properly. A policy issued on incomplete information is a policy that gets contested at claim time, which is precisely when you have the least capacity to fight about it.",
      },
      {
        type: "h2",
        text: "Do not choose on price alone",
      },
      {
        type: "p",
        text:
          "Consider the insurer's record of settling claims, how many conditions are covered and at what severity, and what the service is like when a claim is actually filed. The cheapest policy is poor value if it does not pay, and the difference in premium between a weak plan and a strong one is often smaller than people assume.",
      },
      {
        type: "h2",
        text: "Who it is for",
      },
      {
        type: "p",
        text:
          "Critical illness insurance is not aimed at a particular group. Health changes without warning, and the costs of a serious diagnosis can consume savings built over a working lifetime. It is worth a conversation for anyone with dependents, a mortgage, or self employment income that stops the moment they do.",
      },
      {
        type: "p",
        text:
          "**Call (604) 996 6862** for a free consultation. 8128 128 St #302, Surrey, BC V3W 1R1 [info@abhifinancial.com](mailto\\:info@abhifinancial.com)",
      },
    ],
  },
  {
    slug: "denied-life-insurance-what-to-do-next",
    title: "Denied Life Insurance? Here's What To Do Next",
    category: "Life Insurance",
    date: "June 10, 2025",
    readTime: "6 minutes",
    image:
      "https://images.pexels.com/photos/7876501/pexels-photo-7876501.jpeg",
    excerpt:
      "A declined application isn't the end of the road. Three practical steps to take if a life insurance company has denied your request.",
    author: "Sandeep Ahuja",
    authorRole: "Founder and Licensed Insurance Advisor",
    authorOrganization: "Abhi Insurance Agency",
    metaTitle:
      "Denied Life Insurance in Canada? What To Do Next | Abhi Insurance",
    metaDescription:
      "A declined life insurance application is not the end. Three practical steps after a denial, and how underwriting differences between insurers can change the outcome.",
    related: [
      {
        slug: "how-much-life-insurance-do-you-need",
        label: "How Much Life Insurance Do You Actually Need",
      },
      {
        slug: "choosing-critical-illness-insurance-plan",
        label: "What To Know Before Choosing a Critical Illness Plan",
      },
    ],
    content: [
      {
        type: "p",
        text:
          "A declined life insurance application lands harder than most financial setbacks. It feels like a verdict on your health delivered by a company that has never met you, and many people never apply again.",
      },
      {
        type: "p",
        text:
          "That reaction is understandable and usually wrong. Insurers underwrite differently from one another, sometimes dramatically. A decline from one company is a decline from that company. It is not a statement about whether you are insurable.",
      },
      {
        type: "p",
        text: "Here is what to do instead of giving up.",
      },
      {
        type: "h2",
        text: "Step one, find out exactly why",
      },
      {
        type: "p",
        text:
          "Insurers assess risk using medical records, prescription histories, driving records and financial information. Any of these can trigger a decline, and the specific reason is often much narrower than applicants assume.",
      },
      {
        type: "p",
        text:
          "Request it. You are entitled to know. People expect to hear something about a serious diagnosis and instead learn the issue was an unexplained test result, a medication flagged for a condition they do not have, or a driving record item from years ago.",
      },
      {
        type: "p",
        text:
          "You cannot address a problem you have not identified, and the answer frequently makes the next application straightforward.",
      },
      {
        type: "h2",
        text: "Step two, confirm the information is accurate",
      },
      {
        type: "p",
        text:
          "Mistakes happen more often than the industry likes to admit. Records get mixed up. Test results come back wrong. A prescription written for one purpose gets interpreted as evidence of another condition entirely.",
      },
      {
        type: "p",
        text:
          "Check the data the decision rested on. If a poor test result drove it, have your own physician review and confirm it. Make sure your financial and personal details were recorded correctly, particularly income and existing coverage, which affect how much an insurer is willing to issue.",
      },
      {
        type: "p",
        text: "Correcting an error is often the whole solution.",
      },
      {
        type: "h2",
        text: "Step three, apply through an advisor who knows the differences",
      },
      {
        type: "p",
        text: "This is where the outcome usually changes.",
      },
      {
        type: "p",
        text:
          "Every insurer has its own underwriting rules, and they diverge more than most people realise. One company treats controlled diabetes as a manageable risk with a modest rating. Another declines it. One is comfortable with a particular cardiac history, another is not. These differences are not published in any customer facing document.",
      },
      {
        type: "p",
        text:
          "An advisor who places policies every week knows which companies are accommodating on which conditions. Directing your application to an insurer likely to accept it is the difference between a second decline and a policy in force. Reapplying blind to another big name is just repeating the experiment.",
      },
      {
        type: "h2",
        text: "If the reason is serious, other options exist",
      },
      {
        type: "p",
        text:
          "Sometimes the underlying issue is significant enough that standard underwriting will not work anywhere. Coverage remains available.",
      },
      {
        type: "p",
        text:
          "**Simplified issue policies** ask a short list of medical questions with no medical exam. Approval is faster and the bar is lower.",
      },
      {
        type: "p",
        text:
          "**Guaranteed issue policies** ask no medical questions at all and cannot decline you.",
      },
      {
        type: "p",
        text:
          "Both cost more per dollar of coverage than a standard policy, and guaranteed issue policies typically carry a waiting period, often two years, before the full death benefit is payable. That makes them a fallback rather than a first choice. But for someone who has been told no repeatedly, a policy that pays in two years is a great deal better than no policy at all.",
      },
      {
        type: "h2",
        text: "The point",
      },
      {
        type: "p",
        text:
          "A decline is information, not a conclusion. Find out the reason, check it is accurate, and apply again through somebody who knows where your application will land well.",
      },
      {
        type: "p",
        text:
          "**Call (604) 996 6862** for a free consultation. 8128 128 St #302, Surrey, BC V3W 1R1 [info@abhifinancial.com](mailto\\:info@abhifinancial.com)",
      },
    ],
  },
  {
    slug: "how-much-life-insurance-do-you-need",
    title:
      "How Much Life Insurance Do You Actually Need? A Simple Canadian Guide",
    category: "Life Insurance",
    date: "May 22, 2025",
    readTime: "7 minutes",
    image:
      "https://images.unsplash.com/photo-1631651693480-97f1132e333d",
    excerpt:
      "A practical framework for calculating your life insurance coverage — debts, income replacement, education costs and final expenses.",
    author: "Sandeep Ahuja",
    authorRole: "Founder and Licensed Insurance Advisor",
    authorOrganization: "Abhi Insurance Agency",
    metaTitle:
      "How Much Life Insurance Do You Need? Canadian Guide | Abhi Insurance",
    metaDescription:
      "A simple framework for calculating life insurance coverage in Canada, with a worked example: debts, income replacement, mortgage and education, minus existing cover.",
    related: [
      {
        slug: "denied-life-insurance-what-to-do-next",
        label: "Denied Life Insurance? Here's What To Do Next",
      },
      {
        slug: "super-visa-insurance-requirements-guide",
        label: "Super Visa Insurance Requirements",
      },
    ],
    content: [
      {
        type: "p",
        text:
          "Most people arrive at a life insurance figure the same way: somebody mentions ten times your salary, it sounds like a reasonable rule, and that becomes the number.",
      },
      {
        type: "p",
        text:
          "It is not a terrible starting point. It is also not an answer, because it ignores your mortgage, your debts, your children's ages, and whatever coverage you already hold through work. Two families with identical incomes can need wildly different amounts.",
      },
      {
        type: "p",
        text:
          "Here is a framework that takes about fifteen minutes and produces a figure you can actually defend.",
      },
      {
        type: "h2",
        text: "Add up four numbers",
      },
      {
        type: "p",
        text:
          "**Debt.** Total your outstanding debts excluding the mortgage. Loans, credit cards, car payments, lines of credit. These do not disappear when you do.",
      },
      {
        type: "p",
        text:
          "**Income.** Multiply your annual income by the number of years your family would need support. Ten years is a common default, though families with young children often need considerably longer. Think about it in terms of the youngest child reaching independence rather than picking a round number.",
      },
      {
        type: "p",
        text:
          "**Mortgage.** The full amount needed to clear it. A paid off home is the single largest thing you can leave a surviving partner, because it removes the biggest monthly obligation in most households.",
      },
      {
        type: "p",
        text:
          "**Education.** Estimated future education costs per child. Post secondary education in Canada is not cheap, and this is one of the first things a struggling household cuts.",
      },
      {
        type: "h2",
        text: "Then subtract what you already have",
      },
      {
        type: "p",
        text:
          "Existing coverage counts, but read it carefully before relying on it.",
      },
      {
        type: "p",
        text:
          "Group coverage through work is typically one or two times salary, which sounds meaningful until you compare it to the four numbers above. More importantly, it usually ends when the job does. If you change employers, get laid off, or retire, it goes with you out the door, and by then you are older and possibly less insurable.",
      },
      {
        type: "p",
        text: "Treat group coverage as a supplement. Do not build a plan on it.",
      },
      {
        type: "h2",
        text: "A worked example",
      },
      {
        type: "p",
        text:
          "A couple in their thirties. Two young children. $500,000 remaining on the mortgage, $30,000 in other debts, and a household income of $95,000 from the primary earner. They have $150,000 of group coverage through work.",
      },
      {
        type: "p",
        text:
          "Debt: $30,000 Income replacement at ten years: $950,000 Mortgage: $500,000 Education at roughly $60,000 per child: $120,000",
      },
      {
        type: "p",
        text:
          "Total need: $1,600,000 Less existing coverage: $150,000 **Target: approximately $1,450,000**",
      },
      {
        type: "p",
        text:
          "That figure looks alarming until you price it. At that age, in reasonable health, a twenty year term policy of that size costs a fraction of what most families assume. It is only alarming if you were imagining permanent coverage, which for this family would be the wrong product anyway.",
      },
      {
        type: "h2",
        text: "The things the formula misses",
      },
      {
        type: "p",
        text:
          "**Your spouse's earning capacity.** A partner with a strong income of their own changes the calculation substantially. A partner who has been out of the workforce raising children does not simply return to their old salary.",
      },
      {
        type: "p",
        text:
          "**Childcare.** If you currently share childcare and one parent would need to pay for it or reduce their hours, that is a real ongoing cost the formula does not capture.",
      },
      {
        type: "p",
        text:
          "**Final expenses and estate costs.** Funeral costs, legal fees and taxes are consistently underestimated. Add something for them.",
      },
      {
        type: "p",
        text:
          "**Whether term or permanent suits your goals.** The number tells you how much. It does not tell you what kind. For most families with a mortgage and children at home, term is the right answer and it makes a large figure affordable.",
      },
      {
        type: "h2",
        text: "Run it properly once",
      },
      {
        type: "p",
        text:
          "Fifteen minutes with a spreadsheet gets you close. A conversation with an advisor gets you a figure that accounts for your actual circumstances, plus a comparison of what different insurers would charge for it, which can vary more than people expect for identical coverage.",
      },
      {
        type: "p",
        text: "Consultations with Abhi Insurance Agency are always free.",
      },
      {
        type: "p",
        text:
          "**Call (604) 996 6862** 8128 128 St #302, Surrey, BC V3W 1R1 [info@abhifinancial.com](mailto\\:info@abhifinancial.com)",
      },
    ],
  },
].map((post) => ({
  ...post,
  authorImage: ADVISOR.image,
}));

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services", dropdown: true },
  { label: "Insights", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const DISCLAIMER =
  "Disclaimer: The information on this website is provided for general informational purposes only and does not constitute financial, legal or insurance advice. Insurance products, eligibility requirements, government program rules (including Super Visa requirements) and rates are subject to change and vary by individual circumstances. Please consult a licensed insurance advisor and refer to official Government of Canada (IRCC) resources before making any decisions.";

// -------- localStorage helpers (MOCK persistence) --------

const read = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || [];
  } catch {
    return [];
  }
};

export const saveQuoteRequest = (data) => {
  const all = read("abhi_quote_requests");
  all.push({
    ...data,
    id: Date.now(),
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem("abhi_quote_requests", JSON.stringify(all));
  return true;
};

export const saveContactMessage = (data) => {
  const all = read("abhi_contact_messages");
  all.push({
    ...data,
    id: Date.now(),
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem("abhi_contact_messages", JSON.stringify(all));
  return true;
};

export const saveNewsletter = (email) => {
  const all = read("abhi_newsletter");
  all.push({
    email,
    id: Date.now(),
    createdAt: new Date().toISOString(),
  });
  localStorage.setItem("abhi_newsletter", JSON.stringify(all));
  return true;
};